class ovatBillRuleCtrl {
    constructor($scope, httpRequest, $location, $stateParams, splitTips) {
        const { ruleSchemaCode } = $stateParams;
        $scope.listLimitSpecialShow = false;
        $scope.listLimitGeneralShow = false;
        $scope.listLimitElectronShow = false;
        $scope.checkAmount = function (item) {
            for (const key in item.amountMap) {
                ((!item.amountMap[key] &&
                    item.amountMap[key] !== 0 &&
                    item.amountMap[key] !== null) ||
                    item.amountMap[key] < 0) &&
                    (item.amountMap[key] = 0);
            }
            for (let i = 0; i < $scope.qryBillRuleInfo.externalList.length; i++) {
                const item = $scope.qryBillRuleInfo.externalList[i];
                if (item.splitRuleCode == "split_amount" && item.selected == 1) {
                    if (!isRuledMoney(item.amountMap[0])) {
                        $scope.amountState.special = true;
                        return;
                    }
                    if (!isRuledMoney(item.amountMap[2])) {
                        $scope.amountState.normal = true;
                        return;
                    }
                    if (!isRuledMoney(item.amountMap[51])) {
                        $scope.amountState.ele = true;
                        return;
                    }
                    if (!isRuledMoney(item.amountMap[41])) {
                        $scope.amountState.roll = true;
                        return;
                    }
                    if (!isRuledMoney(item.amountMap[61])) {
                        $scope.amountState.allEleSpecialInvoiceAmount = true;
                        return;
                    }
                    if (!isRuledMoney(item.amountMap[62])) {
                        $scope.amountState.allEleCommonInvoiceAmount = true;
                        return;
                    }
                }
            }
        };
        $scope.amountFocus = function (v) {
            $scope.amountState[v] = false;
        };
        $scope.splitRegexList = [",", "/", "\\", "换行"];
        // 获取拆合规则信息
        httpRequest.get_qryRuleInfo(ruleSchemaCode).then((res) => {
            $scope.qryBillRuleInfo = res.data.value;
            $scope.qryBillRuleInfo.amtNumber = $scope.qryBillRuleInfo.amtNumber
                ? +$scope.qryBillRuleInfo.amtNumber
                : 15;
            $scope.qryBillRuleInfo.priceNumber = $scope.qryBillRuleInfo.priceNumber
                ? +$scope.qryBillRuleInfo.priceNumber
                : 15;
            $scope.qryBillRuleInfo.amtNumberTax4 = $scope.qryBillRuleInfo.amtNumberTax4 ? +$scope.qryBillRuleInfo.amtNumberTax4 : 13
            $scope.qryBillRuleInfo.priceNumberTax4 = $scope.qryBillRuleInfo.priceNumberTax4 ? +$scope.qryBillRuleInfo.priceNumberTax4 : ''
            $scope.qryBillRuleInfo.invRemarkRule =
                $scope.qryBillRuleInfo.invRemarkRule || "0";
            $scope.qryBillRuleInfo.splitAmountTaxMark =
                $scope.qryBillRuleInfo.splitAmountTaxMark || "0";
            $scope.qryBillRuleInfo.splitRegex =
                $scope.qryBillRuleInfo.splitRegex || $scope.splitRegexList[0];
            $scope.qryBillRuleInfo.remarkRepeat =
                $scope.qryBillRuleInfo.remarkRepeat || "1";
        });
        // $scope.qryBillRuleInfo = {};
        // //获取销售单拆合规则
        // httpRequest.get_qryBillRuleInfo().then(res => {
        //     $scope.qryBillRuleInfo = res.data.value
        // })
        $scope.validateRules = {};
        // 清单发票最多行数校验
        function regTest(value, limit) {
            const regex = /^[1-9][0-9]{0,3}$/;
            return regex.test(value) && value <= limit;
        }

        $scope.checkNumber = function checkNumber() {
            if ($scope.qryBillRuleInfo.priceNumber % 1 != 0) {
                $scope.qryBillRuleInfo.priceNumber = parseInt(
                    $scope.qryBillRuleInfo.priceNumber
                );
            }
            if ($scope.qryBillRuleInfo.amtNumber % 1 != 0) {
                $scope.qryBillRuleInfo.amtNumber = parseInt(
                    $scope.qryBillRuleInfo.amtNumber
                );
            }
            if (
                !(
                    $scope.qryBillRuleInfo.priceNumber >= 1 &&
                    $scope.qryBillRuleInfo.priceNumber <= 15
                )
            )
                $scope.qryBillRuleInfo.priceNumber = 15;
            if (
                !(
                    ($scope.qryBillRuleInfo.amtNumber > 0 &&
                        $scope.qryBillRuleInfo.amtNumber <= 15) ||
                    $scope.qryBillRuleInfo.amtNumber === 0
                )
            )
                $scope.qryBillRuleInfo.amtNumber = 15;
        };
        $scope.checkNumberTax4 = function checkNumber() {
            if ($scope.qryBillRuleInfo.priceNumberTax4 % 1 != 0) {
                $scope.qryBillRuleInfo.priceNumberTax4 = parseInt($scope.qryBillRuleInfo.priceNumberTax4)
            }
            if ($scope.qryBillRuleInfo.amtNumberTax4 % 1 != 0) {
                $scope.qryBillRuleInfo.amtNumberTax4 = parseInt($scope.qryBillRuleInfo.amtNumberTax4)
            }
            if (!($scope.qryBillRuleInfo.priceNumberTax4 >= 1 && $scope.qryBillRuleInfo.priceNumberTax4 <= 13)) $scope.qryBillRuleInfo.priceNumberTax4 = ''
            if (!(($scope.qryBillRuleInfo.amtNumberTax4 > 0 && $scope.qryBillRuleInfo.amtNumberTax4 <= 13) || $scope.qryBillRuleInfo.amtNumberTax4 === 0)) $scope.qryBillRuleInfo.amtNumberTax4 = 13
        }

        $scope.check = function check(event, toggle) {
            $scope[toggle] = !regTest(event.target.value, 2000);
        };
        $scope.checkSpe = function checkSpe(event, toggle) {
            $scope[toggle] = !regTest(event.target.value, 50)
        }

        // 是否符合金钱，小数点前12位，后两位
        function isRuledMoney(argument) {
            const reg = /(^[1-9][0-9]{0,11}$)|(^[0]$)|(^[0]\.\d{0,2}$)|(^[1-9][0-9]{0,11}\.\d{0,2}$)/;
            return reg.test(argument);
        }
        $scope.amountState = {};
        // 保存销售单拆合规则
        $scope.save = function save() {
            if (
                !$scope.listLimitElectronShow &&
                !$scope.listLimitGeneralShow &&
                !$scope.listLimitSpecialShow &&
                ($scope.qryBillRuleInfo.externalList[1].selected != 1 ||
                    (!$scope.amountState.special &&
                        !$scope.amountState.normal &&
                        !$scope.amountState.ele &&
                        !$scope.amountState.roll &&
                        !$scope.amountState.allEleSpecialInvoiceAmount &&
                        !$scope.amountState.allEleCommonInvoiceAmount))
            ) {
                $scope.qryBillRuleInfo.externalRule = null;
                httpRequest
                    .post_setupRule($scope.qryBillRuleInfo, "保存成功")
                    .then(() => {
                        $location.path("/system/settingcenter/ovatBillRule/list").replace();
                    });
            }
        };
        // 取消
        $scope.cancle = function cancle() {
            $location.path("/system/settingcenter/ovatBillRule/list").replace();
        };
        $scope.openTips = function (v) {
            splitTips(v);
        };
    }
}

ovatBillRuleCtrl.$inject = [
    "$scope",
    "httpRequest",
    "$location",
    "$stateParams",
    "splitTips",
];
export default ovatBillRuleCtrl;



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/ovatBillRule/ovatBillRuleCtrl.js